import { API_BASE } from "@/lib/api";
import { Mic } from "lucide-react";
import VoicePlayer from "@/components/VoicePlayer";
import { useFileToken, buildPhotoHref } from "@/hooks/useFileToken";

/**
 * Docket preview stack — photo (if any), voice player (if any), or raw transcript.
 * Renders nothing if none of the three exist.
 */
export default function DocketPreviewCard({ photoPath, voicePath, transcript }) {
  const fileToken = useFileToken();
  const hasAny = !!photoPath || !!voicePath || !!transcript;
  if (!hasAny) return null;
  return (
    <>
      {photoPath && (
        <div className="bi-surface p-2" data-testid="rv-photo-card">
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 px-2 pt-1 pb-2 font-heading">
            Original receipt
          </div>
          <a
            href={buildPhotoHref({ path: photoPath, token: fileToken, supplier: "receipt" })}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <img
              data-testid="rv-photo"
              src={`${API_BASE}/api/files/${photoPath}`}
              alt="receipt"
              className="w-full max-h-[320px] object-contain rounded-lg bg-black/40"
            />
          </a>
        </div>
      )}
      {voicePath && (
        <VoicePlayer voicePath={voicePath} transcript={transcript} testid="rv-voice-player" />
      )}
      {!voicePath && transcript && (
        <div className="bi-surface p-3 text-sm text-white/80" data-testid="rv-transcript">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-heading text-white/50 mb-1">
            <Mic className="w-3 h-3" /> Transcript
          </div>
          &ldquo;{transcript}&rdquo;
        </div>
      )}
    </>
  );
}
